import React from 'react';

const LABELS = {
  draft: 'Draft',
  submitted: 'Submitted',
  pending_review: 'Pending Review',
  approved: 'Approved',
  live: 'Live',
  rejected: 'Rejected',
  needs_correction: 'Needs Correction',
  flagged: 'Flagged',
  suspended: 'Suspended',
  expired: 'Expired',
  sold: 'Sold',
};

const STYLES = {
  draft: 'bg-secondary text-secondary-foreground border-border',
  submitted: 'status-pending',
  pending_review: 'status-pending',
  approved: 'status-approved',
  live: 'status-live',
  needs_correction: 'status-needs',
  rejected: 'status-rejected',
  suspended: 'status-suspended',
  flagged: 'status-rejected',
  expired: 'bg-secondary text-secondary-foreground border-border',
  sold: 'bg-emerald-600 text-white border-emerald-700',
};

export const StatusPill = ({ status, size = 'sm' }) => {
  const cls = STYLES[status] || 'bg-secondary';
  const label = LABELS[status] || status;
  const sz = size === 'lg' ? 'text-sm px-3 py-1' : 'text-[11px] px-2 py-0.5';
  return (
    <span
      data-testid='moderation-status-pill'
      className={`inline-flex items-center rounded-full border font-medium ${cls} ${sz}`}
    >
      {label}
    </span>
  );
};

export default StatusPill;
